import request from '@/util/request'

export function getAliyunPrivateOSSPostAuthorization(query) {
  return request({
    url: '/api/FileOperator/GetAliyunPrivateOSSPostAuthorization',
    method: 'get',
    params: query
  })
}

export function getAliyunPulicOSSPostAuthorization(query) {
  return request({
    url: '/api/FileOperator/GetAliyunPublicOSSPostAuthorization',
    method: 'get',
    params: query
  })
}

export function getAliyunOSSDownloadAuthorization(query) {
  return request({
    url: '/api/FileOperator/GetAliyunOSSDownloadAuthorization',
    method: 'get',
    params: query
  })
}

// 临时下载cv接口
export function getAliyunOSSDownloadAuthorizationPX(query) {
  return request({
    url: '/api/LeadAccount/GetAliyunOSSDownloadAuthorizationPX',
    method: 'get',
    params: { fileName: query }
  })
}

export function uploadFile(host, formData) {
  return request({
    method: 'post',
    url: host,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function uploadFileToSys(formData) {
  return request({
    method: 'post',
    url: '/api/FileOperator/UploadFiles',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function uploadFileWithSign(formData) {
  return request({
    method: 'post',
    url: '/api/PublicEventRegister/UploadFilesWithSign',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// Share
export function sharingUploadFile(formData) {
  return request({
    method: 'post',
    url: '/api/Sharing/UploadFiles',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
